
          export default {
            mounted() {
              this.handleEvent("clear-invite-form", () => this.el.reset())
            }
          }
        